import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "rightSideDetailsPanelFloat";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
export const localStorageSettingsKey = "ohotnik.rightSideDetailsPanel.settings";
